import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import preventDefaultPropagation from 'client/helpers/preventDefaultPropagation';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrLink from 'client/components/SrLink/SrLink';

import './SrCollapsibleContainer.less';

export const SR_COLLAPSIBLE_CONTAINER_STATUS_NOT_STARTED =
  'SR_COLLAPSIBLE_CONTAINER_STATUS_NOT_STARTED';
export const SR_COLLAPSIBLE_CONTAINER_STATUS_COMPLETE = 'SR_COLLAPSIBLE_CONTAINER_STATUS_COMPLETE';
export const SR_COLLAPSIBLE_CONTAINER_STATUS_IN_PROGRESS =
  'SR_COLLAPSIBLE_CONTAINER_STATUS_IN_PROGRESS';
export const SR_COLLAPSIBLE_CONTAINER_STATUS_ERROR = 'SR_COLLAPSIBLE_CONTAINER_STATUS_ERROR';
const SR_COLLAPSIBLE_CONTAINER_STATUS_TO_CLASSNAME_MAPPING = {
  [SR_COLLAPSIBLE_CONTAINER_STATUS_NOT_STARTED]: 'status-not-started',
  [SR_COLLAPSIBLE_CONTAINER_STATUS_COMPLETE]: 'status-complete',
  [SR_COLLAPSIBLE_CONTAINER_STATUS_IN_PROGRESS]: 'status-in-progress',
  [SR_COLLAPSIBLE_CONTAINER_STATUS_ERROR]: 'status-error',
};
export const SR_COLLAPSIBLE_CONTAINER_STATUSES = Object.keys(
  SR_COLLAPSIBLE_CONTAINER_STATUS_TO_CLASSNAME_MAPPING,
); // eslint-disable-line max-len

export const SR_COLLAPSIBLE_CONTAINER_BORDER_TYPE_ROUNDED =
  'SR_COLLAPSIBLE_CONTAINER_BORDER_TYPE_ROUNDED';
export const SR_COLLAPSIBLE_CONTAINER_BORDER_TYPE_BOTTOM_GRAY =
  'SR_COLLAPSIBLE_CONTAINER_BORDER_TYPE_BOTTOM_GRAY'; // eslint-disable-line max-len
const SR_COLLAPSIBLE_CONTAINER_BORDER_TYPE_TO_CLASSNAME_MAPPING = {
  [SR_COLLAPSIBLE_CONTAINER_BORDER_TYPE_ROUNDED]: 'border-type-rounded',
  [SR_COLLAPSIBLE_CONTAINER_BORDER_TYPE_BOTTOM_GRAY]: 'border-type-bottom-gray',
};
export const SR_COLLAPSIBLE_CONTAINER_BORDER_TYPES = Object.keys(
  SR_COLLAPSIBLE_CONTAINER_BORDER_TYPE_TO_CLASSNAME_MAPPING,
); // eslint-disable-line max-len

export const SR_COLLAPSIBLE_CONTAINER_EDIT_BUTTON_THEME_TEXT =
  'SR_COLLAPSIBLE_CONTAINER_EDIT_BUTTON_THEME_TEXT'; // eslint-disable-line max-len
export const SR_COLLAPSIBLE_CONTAINER_EDIT_BUTTON_THEME_BLUE =
  'SR_COLLAPSIBLE_CONTAINER_EDIT_BUTTON_THEME_BLUE'; // eslint-disable-line max-len

const SrCollapsibleContainer = ({
  children,
  title,
  subtitle,
  titleColor,
  status,
  borderType,
  isExpanded,
  editLinkUrl,
  onEditClick,
  editButtonTheme,
  onClick,
  hideIcon,
}) => {
  return (
    <SrBox
      styleName={classnames(
        'SrCollapsibleContainer',
        SR_COLLAPSIBLE_CONTAINER_BORDER_TYPE_TO_CLASSNAME_MAPPING[borderType],
        SR_COLLAPSIBLE_CONTAINER_STATUS_TO_CLASSNAME_MAPPING[status],
      )}
    >
      <div styleName={classnames('headerContainer', onClick ? 'pointer' : null)} onClick={onClick}>
        <div>
          {!hideIcon && (
            <img
              src={`/images/${SR_COLLAPSIBLE_CONTAINER_STATUS_TO_CLASSNAME_MAPPING[status]}-icon.svg`}
              alt="status icon"
              width="12px"
              height="auto"
              style={{ margin: '0 10px 0 0' }}
            />
          )}
          <SrText font="greycliff" color={titleColor} weight="700" size="18" lineHeight="22px">
            {title}
          </SrText>
          {subtitle && (
            <SrText
              font="greycliff"
              color="blueGreycliff"
              weight="600"
              size="18"
              lineHeight="22px"
              paddingLeft="8px"
            >
              {subtitle}
            </SrText>
          )}
        </div>
        {(editLinkUrl || onEditClick) && (
          <span onClick={preventDefaultPropagation}>
            {editButtonTheme === SR_COLLAPSIBLE_CONTAINER_EDIT_BUTTON_THEME_TEXT ? (
              <SrLink
                to={editLinkUrl}
                onClick={onEditClick}
                font="greycliff"
                color="grey"
                weight="600"
                size="12"
                lineHeight="14px"
                cursor="pointer"
              >
                Edit
              </SrLink>
            ) : (
              <SrLink to={editLinkUrl} onClick={onEditClick}>
                <SrText
                  font="greycliff"
                  color="blue300"
                  weight="700"
                  size="14"
                  lineHeight="14px"
                  cursor="pointer"
                >
                  Edit
                </SrText>
              </SrLink>
            )}
          </span>
        )}
      </div>
      {isExpanded && <SrBox styleName="contentContainer">{children}</SrBox>}
    </SrBox>
  );
};

SrCollapsibleContainer.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  titleColor: PropTypes.string,
  status: PropTypes.oneOf(SR_COLLAPSIBLE_CONTAINER_STATUSES),
  borderType: PropTypes.oneOf(SR_COLLAPSIBLE_CONTAINER_BORDER_TYPES),
  editLinkUrl: PropTypes.string,
  isExpanded: PropTypes.bool,
  onClick: PropTypes.func,
  onEditClick: PropTypes.func,
  editButtonTheme: PropTypes.oneOf([
    SR_COLLAPSIBLE_CONTAINER_EDIT_BUTTON_THEME_TEXT,
    SR_COLLAPSIBLE_CONTAINER_EDIT_BUTTON_THEME_BLUE,
  ]),
  hideIcon: PropTypes.bool,
};

SrCollapsibleContainer.defaultProps = {
  status: SR_COLLAPSIBLE_CONTAINER_STATUS_COMPLETE,
  isExpanded: false,
  titleColor: 'blueGreycliff',
  editButtonTheme: SR_COLLAPSIBLE_CONTAINER_EDIT_BUTTON_THEME_TEXT,
  hideIcon: false,
};

SrCollapsibleContainer.displayName = 'SrCollapsibleContainer';

export default SrCollapsibleContainer;
